const resumeData = {
	imagebaseurl: 'https://driveofhiren.github.io/',
	name: 'Hiren Gohil',
	role: 'Web Developer, Music Producer, Graphic Designer',
	cv: 'https://drive.google.com/file/d/1s5KAkCp5Oa4t-nz1BMXVxuhjjgk1nfXF/view?usp=drive_link',
	roleDescription: (
		<p style={{ fontSize: '26px' }}>
			I am a skilled professional, adept in the realms of
			<span
				style={{
					color: '#312244',
					margin: '0 5px',
				}}
			>
				IT Systems & Infrastructure
			</span>
			,
			<span
				style={{
					color: '#312244',
					margin: '0 5px',
				}}
			>
				{' '}
				Full Stack Development
			</span>
			, and
			<span
				style={{
					color: '#312244',
					margin: '0 5px',
				}}
			>
				Digital Media Production
			</span>
			, seamlessly blending my creative instincts with technical
			expertise.
		</p>
	),
	socialLinks: [
		{
			name: 'linkedin',
			url: 'https://www.linkedin.com/in/hiren-gohil-362356142/',
			className: 'fab fa-linkedin',
		},
		{
			name: 'github',
			url: 'https://github.com/driveofhiren',
			className: 'fab fa-github',
		},
		// {

		// 	name: 'twitter',
		// 	url: 'https://twitter.com/spirit_toy',
		// 	className: 'fab fa-twitter',
		// },
		{
			name: 'instagram',
			url: 'https://www.instagram.com/h.gohil/',
			className: 'fab fa-instagram',
		},
		// {
		// 	name: 'soundcloud',
		// 	url: 'https://soundcloud.com/spirittoy',
		// 	className: 'fab fa-soundcloud',
		// },
		{
			name: 'youtube',
			url: 'https://www.youtube.com/channel/UCRN6zHj_YuzDrH9qTw6FMIQ',
			className: 'fab fa-youtube',
		},
		// {
		// 	name: 'spotify',
		// 	url: 'https://open.spotify.com/artist/4G4Ko6bMdUf1hADOhCkd4c',
		// 	className: 'fab fa-spotify',
		// },
		{
			name: 'instagram',
			url: 'https://www.instagram.com/spirit.toy/',
			className: 'fab fa-instagram',
		},
	],

	aboutme:
		"I'm Hiren Yogeshbhai Gohil, a tech enthusiast with a Bachelor's in Information & Technology from SVIT, Vasad, India, and currently pursuing Web Development at Conestoga College. I have a diverse background, having worked as a Technician, Graphic Designer, and Music Producer for multiple record labels. Let's innovate together!",

	email: 'hirengohil7792@gmail.com',
	phone: '+1-437-799-3689',
	instagramId: 'h.gohil',
	soundcloudId: 'spirittoy',
	youtubeId: '@spirittoy5420',
	linkedinId: 'hiren-gohil-362356142',
	spotifyId: '4G4Ko6bMdUf1hADOhCkd4c',
	education: [
		{
			UniversityName: 'Conestoga College',
			specialization: 'Web Development(Post Graduation)',
			MonthOfPassing: 'April',
			YearOfPassing: '2024',
			Achievements: '3.67 GPA',
		},
		{
			UniversityName: 'SVIT, Vasad',
			specialization: 'Information & Technology(Bachelors)',
			MonthOfPassing: 'July',
			YearOfPassing: '2020',
			Achievements: '3.12 GPA',
		},
	],
	work: [
		{
			CompanyName: 'Shivam Computer',
			specialization: 'Technician',
			MonthOfLeaving: 'April',
			YearOfLeaving: '2014',
			Achievements: '',
		},
		{
			CompanyName: 'Numerator',
			specialization: 'Data Classification Associate',
			MonthOfLeaving: 'Dec',
			YearOfLeaving: '2022',
			Achievements: '',
		},
	],
	skillsDescription: 'Your skills here',
	skills: [
		// Front-End Development
		{
			skillname: 'HTML5, CSS, Tailwind CSS',
		},
		{
			skillname: 'JavaScript, React.js, Next.js',
		},
		{
			skillname: 'Figma, Adobe XD, Photoshop, Illustrator, Canva',
		},
		{
			skillname: 'WordPress',
		},

		// Back-End & Full-Stack Development
		{
			skillname: 'Node.js, Express.js, PHP, ASP.NET',
		},
		{
			skillname: 'Python (Flask, Django)',
		},
		{
			skillname: 'GraphQL, RESTful APIs',
		},

		// Databases
		{
			skillname: 'SQL, MongoDB, Firebase',
		},

		// Cloud & DevOps
		{
			skillname: 'AWS (EC2, S3, Lambda), Docker, GitHub',
		},

		// AI, Data & Machine Learning
		{
			skillname:
				'Python (Pandas, NumPy), Generative AI, Prompt Engineering, ML Basics',
		},

		// System & IT Administration
		{
			skillname:
				'System Administration, Network Fundamentals, ServiceNow',
		},
		{
			skillname:
				'Hardware/Software Troubleshooting (Windows/macOS/Linux)',
		},

		// Multimedia & Creative Production
		{
			skillname:
				'Adobe Premiere Pro, After Effects, FL Studio, Adobe Audition',
		},

		// Productivity Tools
		{
			skillname: 'Microsoft Office Suite (Word, Excel, PowerPoint)',
		},
	],
	graphics: [
		{
			id: 7,
			name: 'Social Media',
			embedUrl:
				'https://drive.google.com/file/d/1-io_4R8CqXJXUQKHfARDnwmoZTUeAiWl/preview',
		},
		{
			id: 1,
			name: 'T-Shirt',
			embedUrl:
				'https://drive.google.com/file/d/1-CCdp-HU7taAHy1J_myxQ0P--D2O6nnv/preview',
		},
		{
			id: 2,
			name: 'Logo',
			embedUrl:
				'https://drive.google.com/file/d/1-DhXbhKMuBvbnjI9l2Xjmk-hxYLrspVz/preview',
		},
		{
			id: 3,
			name: 'Certificate',
			embedUrl:
				'https://drive.google.com/file/d/1-GxC9PHiH8yqqjjindupyH1auUJS8ORb/preview',
		},
		{
			id: 4,
			name: 'ID Card',
			embedUrl:
				'https://drive.google.com/file/d/1-fwGujVPcKlX2mfYl5_ekGqSmX6i4Ppf/preview',
		},
		{
			id: 5,
			name: 'Certificate',
			embedUrl:
				'https://drive.google.com/file/d/1-i_dC_GBulF_SPETmwKzFJIjKbgroj4u/preview',
		},
		{
			id: 6,
			name: 'Social Media',
			embedUrl:
				'https://drive.google.com/file/d/1-sEU3LgQ0zBiS3MzNjRmQAkNl_4gPeN7/preview',
		},

		{
			id: 8,
			name: 'Social Media',
			embedUrl:
				'https://drive.google.com/file/d/1-py3ZOOUVQh0uXKG54WUNegH4EV2YKfg/preview',
		},
		{
			id: 9,
			name: 'Social Media',
			embedUrl:
				'https://drive.google.com/file/d/1-kUDar0c7J6IxsN2kXPNukp54LMGV2wo/preview',
		},
		{
			id: 10,
			name: 'Social Media',
			embedUrl:
				'https://drive.google.com/file/d/1-vRaMOBoN17-5LOSHqncUW6Rf8ZbjQMA/preview',
		},
		{
			id: 11,
			name: 'Social Media',
			embedUrl:
				'https://drive.google.com/file/d/1-w7eXfuOttZX73Qy7UsfwLfAg9LDBm1l/preview',
		},
		{
			id: 12,
			name: 'Welcome Banner',
			embedUrl:
				'https://drive.google.com/file/d/1Xtwb8ev4lTZg9HqeG0xQrNLSQ87ItpaM/preview',
		},
		{
			id: 13,
			name: 'Geo Filter Snapchat',
			embedUrl:
				'https://drive.google.com/file/d/109e7-lNB8ZEM8HP8a-l3BROpnkTgJby9/preview',
		},
		{
			id: 14,
			name: 'Momento Design',
			embedUrl:
				'https://drive.google.com/file/d/109lQAx-901hOxSCFIYRsSfqqavIa4Afj/preview',
		},
		{
			id: 15,
			name: 'Geo Filter Snapchat',
			embedUrl:
				'https://drive.google.com/file/d/10E8KB7qKEd7e5gforyDVR2NIkN_Jkau2/preview',
		},
		{
			id: 16,
			name: 'Geo Filter Snapchat',
			embedUrl:
				'https://drive.google.com/file/d/1-zznWj4BAsJfP92Z8K5Ce2aOi-V0qIMv/preview',
		},
		{
			id: 17,
			name: 'Social Media',
			embedUrl:
				'https://drive.google.com/file/d/1X189LCdO8vzsKh2-I59A2xcrrvkvGc5C/preview',
		},
	],

	portfolio: [
		{
			name: 'Live Video to Music Generator',
			description:
				'A real-time AI-powered application that analyzes live video using YOLO, OpenCV, and Places365 to generate dynamic music. It maps objects, scenes, and lighting to musical prompts using generative AI.',
			imgurl: 'https://back-493224371746.us-east1.run.app/',
		},
		{
			name: 'YourStars',
			description:
				'YourStars is a dynamic platform that connects users through shared astrological influences, fostering community and cosmic conversation. By exploring personalized placements and engaging in meaningful discussions, users can deepen their astrological journey.',
			imgurl: 'https://yourstars.vercel.app/',
		},
		{
			name: 'ShiftTime(Shift Schedule Application)',
			description:
				'Streamline employee scheduling and time management effortlessly with ShiftTime, leveraging the power of React.js, Node.js, and Flutter.',
			imgurl: 'https://shifttime.vercel.app/',
		},
		{
			name: 'Judgment-Card game',
			description:
				'Judgement is a strategic card game where players predict how many rounds they will win. Points are earned based on the accuracy of their predictions, with a "Master Suit" adding extra challenge. The player with the most points wins.',
			imgurl: 'http://judgementhiren.s3-website.us-east-2.amazonaws.com/',
		},
		{
			name: 'TorpoDect',
			description:
				'This Python-based project uses face detection to monitor eyes of driver and detect signs of drowsiness. If the system detects the driver falling asleep, it triggers an emergency alarm to prevent accidents.',
			imgurl: 'https://github.com/driveofhiren/TorpoDect',
		},
		{
			name: 'Employee Management Portal',
			description:
				'The Employee Management Portal utilizes React and GraphQL to efficiently manage employee details.',
			imgurl: 'https://github.com/driveofhiren/ems',
		},
		{
			name: 'E-commerce Store',
			description:
				'E-commerce Store is a platform for buying and selling items. It is built on a  foundation of PHP and MySQL, ensuring reliability and flexibility.',
			imgurl: 'https://github.com/driveofhiren/ecomphp',
		},
		{
			name: 'Book Store',
			description:
				'ASP.NET-based e-commerce platform for books, featuring User authentication, Product management, and Order processing. ',
			imgurl: 'https://github.com/driveofhiren/Book-Store',
		},
		{
			name: 'Cosmetics Store',
			description:
				'The Bakery Store website boasts a sleek HTML and CSS design, combining conciseness with an inviting aesthetic.',
			imgurl: 'https://github.com/driveofhiren/Cosmeticd',
		},
		{
			name: 'Bakery Store ',
			description:
				'The Bakery Store is designed with HTML and CSS, focusing on simplicity and user-friendly experience.',
			imgurl: 'https://github.com/driveofhiren/bakery',
		},
		{
			name: 'Musical Artist',
			description:
				'The Musical Artist website is built using HTML, CSS, and WordPress, ensuring a versatile and visually appealing online presence.',
			imgurl: 'https://github.com/driveofhiren/Artist-Website',
		},
	],
	music: [
		{
			id: 1,
			name: 'LoopChild',
			imgurl: 'https://open.spotify.com/track/5q8qBWksVF89iALJPs90Iq?si=ac7c651f89004dd2',
		},
		{
			id: 2,
			name: 'NeuroWeave',
			imgurl: 'https://open.spotify.com/track/1NYk83B7KjQXyj4PVsW66t',
		},
		{
			id: 3,
			name: 'Tanha',
			imgurl: 'https://open.spotify.com/track/2ksraD1lL76YJyGGuhyBmk?si=e73781686b5a4090',
		},
		{
			id: 4,
			name: 'Mahiya',
			imgurl: 'https://open.spotify.com/album/3OVfehhI2muqHQIc4r3wae?si=sfi7XUhiRi2k0kPKp_-dpA',
		},
		{
			id: 5,
			name: 'Masters',
			imgurl: 'https://open.spotify.com/track/1YzO9G2ubLqj6tBjWfY2jG?si=a337a283b9fe4298',
		},
		{
			id: 6,
			name: 'Masters(Slowed and Reverb)',
			imgurl: 'https://open.spotify.com/track/49XBPjiXJqMNTtPhZIclwR?si=623fedc5d7524d9e',
		},
		{
			id: 7,
			name: 'Tranquil',
			imgurl: 'https://open.spotify.com/track/0kY03hvGKov6olyWyg7wey?si=e8457e29a63149ae',
		},
		{
			id: 8,
			name: 'Ashle',
			imgurl: 'https://open.spotify.com/track/6ct4xQaoDpwIlJuKtvVcCL',
		},
		{
			id: 9,
			name: 'Osho Wave',
			imgurl: 'https://open.spotify.com/album/20j9Vc4dMVlP3cyabv14D1?si=9i59uigKQVazTvNjm3q7jw',
		},
	],
}

export default resumeData
